import { render, staticRenderFns } from "./SceneDetail.vue?vue&type=template&id=64c6be89&scoped=true&"
import script from "./SceneDetail.vue?vue&type=script&lang=js&"
export * from "./SceneDetail.vue?vue&type=script&lang=js&"
import style0 from "./SceneDetail.vue?vue&type=style&index=0&id=64c6be89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6be89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c6be89')) {
      api.createRecord('64c6be89', component.options)
    } else {
      api.reload('64c6be89', component.options)
    }
    module.hot.accept("./SceneDetail.vue?vue&type=template&id=64c6be89&scoped=true&", function () {
      api.rerender('64c6be89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/SceneDetail.vue"
export default component.exports